import { createTheme } from "@mui/material/styles";

const THAI_FONT_STACK = [
  "Sarabun",
  "Prompt",
  "Noto Sans Thai",
  "sans-serif",
].join(",");

const THAI_HEADING_FONT_STACK = [
  "Prompt",
  "Sarabun",
  "Noto Sans Thai",
  "sans-serif",
].join(",");

const theme = createTheme({
  typography: {
    fontSize: 16,
    htmlFontSize: 16,
    fontFamily: THAI_FONT_STACK,
    h1: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "clamp(26px, 3.6vw, 34px)",
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h2: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "clamp(22px, 3vw, 28px)",
      fontWeight: 700,
      lineHeight: 1.35,
    },
    h3: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "clamp(20px, 2.6vw, 24px)",
      fontWeight: 700,
      lineHeight: 1.35,
    },
    h4: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "clamp(19px, 2.3vw, 22px)",
      fontWeight: 700,
      lineHeight: 1.4,
    },
    h5: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "clamp(18px, 2vw, 20px)",
      fontWeight: 700,
      lineHeight: 1.45,
    },
    h6: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: 1.45,
    },
    subtitle1: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: 1.55,
    },
    subtitle2: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: 1.55,
    },
    body1: {
      fontFamily: THAI_FONT_STACK,
      fontSize: "16px",
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: THAI_FONT_STACK,
      fontSize: "16px",
      lineHeight: 1.65,
    },
    caption: {
      fontFamily: THAI_FONT_STACK,
      fontSize: "16px",
      lineHeight: 1.6,
    },
    button: {
      fontFamily: THAI_HEADING_FONT_STACK,
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: 1.5,
      textTransform: "none",
    },
  },
  Form: {
    fontFamily: THAI_FONT_STACK,
  },
  barchart: {
    fontFamily: THAI_FONT_STACK,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h2",
          h2: "h2",
          h3: "h2",
          h4: "h2",
          h5: "h2",
          h6: "h2",
          subtitle1: "h2",
          subtitle2: "h2",
          body1: "span",
          body2: "span",
        },
      },
    },
  },
});

export default theme;
